"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCapitalize = (string) => string && string.charAt(0).toUpperCase() + string.slice(1);
//# sourceMappingURL=get-capitalize.js.map